import { c as _c } from "react/compiler-runtime";
import { getSearchSuggestionSubtitle } from "@/utils/searchSuggestionDisplay";
export default function SearchSuggestionSubtitle(t0) {
  const $ = _c(6);
  const {
    search,
    type
  } = t0;
  let t1;
  if ($[0] !== search || $[1] !== type) {
    t1 = getSearchSuggestionSubtitle(search, type);
    $[0] = search;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const subtitle = t1;
  if (!subtitle.text) {
    return null;
  }
  let t2;
  if ($[3] !== subtitle.text || $[4] !== subtitle.title) {
    t2 = <span className="block truncate text-[10px] sm:text-xs text-neutral-500" title={subtitle.title}>{subtitle.text}</span>;
    $[3] = subtitle.text;
    $[4] = subtitle.title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}